import React from 'react';
import { motion } from 'framer-motion';
const episodes = [{
  label: 'CHE 2',
  title: 'WHAT DOES IT LOOK LIKE? THE SIGNS',
  bg: 'bg-pink-400',
  borderColor: 'border-red-500'
}, {
  label: 'CHE 3',
  title: 'WHAT DOES IT FEEL LIKE? THE SYMPTOMS',
  bg: 'bg-blue-600',
  borderColor: 'border-red-500'
}, {
  label: 'CHE 4',
  title: 'LIVING WITH CHRONIC HAND ECZEMA',
  bg: 'bg-emerald-500',
  borderColor: 'border-red-500'
}, {
  label: 'CHE 5',
  title: 'FINDING THE RIGHT SUPPORT AND TOOLS',
  bg: 'bg-orange-400',
  borderColor: 'border-red-500',
  image: 'https://cdn.magicpatterns.com/uploads/jrZCnyjFi8nQvgFu1MYrjp/Screenshot_2026-04-09_at_12.50.13.png'
}];
export function CheMenuScreen() {
  return <section className="min-h-screen w-full bg-white flex flex-col items-center justify-center px-6 py-20" data-id="element-57">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} viewport={{
      once: true,
      margin: '-100px'
    }} className="w-full max-w-6xl" data-id="element-58">
        <h2 className="text-3xl md:text-4xl font-bold text-purple-700 text-center mb-10" data-id="element-59">
          Menu & Episode Branching
        </h2>

        {/* Menu header - "Let's Dive Deeper" */}
        <div className="flex justify-center mb-6" data-id="element-60">
          <div className="border-[3px] border-red-500 rounded-lg bg-gray-200 px-8 py-6 text-center max-w-md w-full" data-id="element-61">
            <h3 className="text-2xl font-black text-black mb-1" data-id="element-62">
              LET'S DIVE DEEPER
            </h3>
            <p className="text-xs font-bold text-black uppercase tracking-wide" data-id="element-63">
              Choose your next episode:
            </p>
          </div>
        </div>

        {/* Connecting lines */}
        <div className="flex justify-center mb-2" data-id="element-64">
          <div className="w-px h-8 bg-red-400" data-id="element-65" />
        </div>
        <div className="flex justify-center mb-2" data-id="element-66">
          <div className="relative w-full max-w-4xl h-6" data-id="element-67">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[80%] h-px bg-red-400" data-id="element-68" />
            {[0, 1, 2, 3].map(i => <div key={i} className="absolute top-0 w-px h-6 bg-red-400" style={{
            left: `${10 + i * (80 / 3)}%`
          }} data-id="element-69" />)}
          </div>
        </div>

        {/* Episode cards row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto" data-id="element-70">
          {episodes.map((ep, i) => <motion.div key={ep.label} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.3 + i * 0.1
        }} className="flex flex-col items-center" data-id="element-71">
              <div className={`border-[3px] ${ep.borderColor} rounded-lg overflow-hidden w-full`} data-id="element-72">
                {ep.image ? <img src={ep.image} alt={ep.title} className="w-full h-auto" data-id="element-73" /> : <div className="flex flex-col" data-id="element-74">
                    {/* Gray top with hand silhouette placeholder */}
                    <div className="bg-gray-200 h-28 flex items-end justify-center" data-id="element-75">
                      <div className="w-16 h-20 bg-gray-400/30 rounded-t-full" data-id="element-76" />
                    </div>
                    {/* Colored bottom with title */}
                    <div className={`${ep.bg} px-3 py-4`} data-id="element-77">
                      <p className="text-sm font-black text-black leading-tight mb-2" data-id="element-78">
                        {ep.title}
                      </p>
                      <div className="inline-block border-2 border-black bg-white px-3 py-1" data-id="element-79">
                        <span className="text-xs font-black text-black" data-id="element-80">
                          READ MORE
                        </span>
                      </div>
                    </div>
                  </div>}
              </div>
              <p className="mt-2 text-sm font-medium text-slate-600" data-id="element-81">
                {ep.label}
              </p>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}